/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import type { FormInstance } from 'antd';
import type { FormModelsState } from 'umi';
import { useSelector, useIntl } from 'umi';
import { MOBILE_CLASS_PREFIX, PC_CLASS_PREFIX } from '@/components/BaseForm/constant';
import { FormContext } from '@/components/BaseForm';
import cn from 'classnames';
import classPrefix from 'prefix-classnames';
import { isMobile } from '@/utils';
import './FormInfo.less';
import PersonalForm from '../PersonalForm';
import StepContext from '../StepRender/StepContext';

export interface FormInfoPopps extends React.HTMLAttributes<HTMLDivElement> {
  // 是否詳情查看狀態，默認false
  isDetail?: boolean;
}

const FormInfo = (props: FormInfoPopps) => {
  const { isDetail = false, className = '', ...otherProps } = props;

  const mobile = isMobile();
  const { formData } = useSelector(({ formModels }: { formModels: FormModelsState }) => formModels);

  const intl = useIntl();
  const context = useContext(StepContext);

  // 移動端和pc端用不用端class前綴
  const px = mobile
    ? classPrefix(`${MOBILE_CLASS_PREFIX}-wrapper`)
    : classPrefix(`${PC_CLASS_PREFIX}-wrapper`);

  return (
    <div className={cn(px('root'), className, { [px('detailRoot')]: isDetail })} {...otherProps}>
      {isDetail && <div className={px('title')}>{intl.formatMessage({ id: '申请资料' })}</div>}
      <div className={px('content')}>
        <FormContext.Provider value={{ isDetail, mobile }}>
          <PersonalForm
            isDetail={isDetail}
            mobile={mobile}
            onInstance={(instance: FormInstance | null) => {
              context.formRenderInstance = instance;
            }}
            values={Object.keys(formData).length > 0 ? formData : undefined}
          />
        </FormContext.Provider>
      </div>
    </div>
  );
};

export default FormInfo;
